import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Card,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@material-ui/core";

import { BuscadorProveedor } from "./BuscadorProveedor";
import { BuscadorOferente} from "../../Cotizaciones/BuscadorOferente"
import {ConsultarOferentes} from "../../../../actions/compras/OferentesAction"
import { TabsProveedores } from "./TabsProveedores";

export const ProveedoresIngreso = (props) => {

  const {Menu} = props;
  const dispatch = useDispatch();
  const [nuevo, setEsNuevo] = useState(false);

    useEffect(() => {
      if(nuevo){
        dispatch(ConsultarOferentes())
      }

    },[dispatch, nuevo])
  
    console.log(Menu)
  return (
    <Grid container justify="center" alignItems="center">
      <Grid item xs={6}>
        <Grid
          container
          spacing={2}
          justify="center"
          alignItems="center"
          component={Card}
          style={{ marginTop: "2rem", marginBottom: "2rem" }}
        >
          <Grid container justify="center">
            <Grid item xs={11}>
              <FormControlLabel
                style={{ marginTop: "1rem" }}
                control={<Checkbox name="nuevo" value={nuevo} onChange={(e)=>setEsNuevo(e.target.checked)} />}
                label="Proveedor Nuevo"
              />
            </Grid>
          </Grid>
          
          {/* Buscador proveedores */}
          <Grid container justify="center">
           { nuevo ? <BuscadorOferente /> : <BuscadorProveedor />}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
              <TabsProveedores esNuevo={nuevo} Menu={Menu} />
      </Grid>
    </Grid>
  );
};
